import tokens from '@ifood/pomodoro-tokens';
import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  .snackbar-container {
    line-height: ${tokens.lineHeights.s};
  }

  body {
    overflow-x: hidden;
    height: unset;
    font-family: ${tokens.font.family.ifood.body};
    font-size: ${tokens.fontSizes.s};
    color: ${tokens.colors.black};
    background-color: ${tokens.colors.white};
  }

  legend {
    width: 100%;
  }

  *, *::before, *::after {
    box-sizing: inherit;
  }

  img {
    vertical-align: middle;
  }

  h1, h2, h3, h4, h5, h6 {
    margin-top: 0;
    margin-bottom: 0.5rem;
    font-family: ${tokens.font.family.ifood.body};
  }

  h4 {
    line-height: 1.5;
  }

  dl, ol, ul {
    margin-top: 0;
  }

  p {
    margin-top: 0;
    margin-bottom: 1rem;
  }

  h3 {
    line-height: 1.33;
  }

  h1, h2, h4 {
    line-height: 1.5;
  }

  h2, h3 {
    font-weight: 500;
  }

  th {
    text-align: left;
  }

  code, kbd, pre, samp {
    font-family: Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;
  }

  code {
    padding: .2rem .4rem;
    font-size: 90%;
    color: #bd4147;
    background-color: #f7f7f9;
    border-radius: .25rem;
  }

  a, button {
    cursor: pointer;
  }

  hr {
    margin-top: ${tokens.space.regular};
    margin-bottom: ${tokens.space.regular};
    border: 0;
    border-top: 1px solid rgba(0,0,0,.1);
  }

  button {
    background: transparent;
    border: none;
    padding: 0;
    font-size: 100%;
    outline: none;
  }

  button:disabled {
    cursor: default;
  }

  .gatsby-resp-image-wrapper {
    white-space: initial;
    margin-top: 35px;
    margin-bottom: 35px;
  }

  .grvsc-container {
    will-change: transform;
    border-radius: 0 !important;
    background-color: #f6f6f6 !important;
    max-width: 610px;
    margin: 25px 0;
  }

  .notifications-action-bar.action-bar {
    padding: 0 ${tokens.space.regular};
  }

  .grvsc-code {
    font-family: monospace;
    line-height: normal;
  }

  .table-responsive {
    overflow-x: unset;
    thead {
      th {
        border: none;
      }
    }
    tbody {
      border-left: none;
      border-right: none;
      border-color: #eceeef;
    }
  }

  .splash-carousel {
    .slick-list {
      height: 500px;
      border-radius: 24px;
      overflow: hidden;
      @media screen and (max-width: ${tokens.breakpoints.s}) {
        border-radius: 0;
      }
    }

    .slick-arrow {
      background-color: ${tokens.colors.grayDarker};
      height: 32px;
      width: 32px;
      display: flex;
      justify-content: center;
      align-items: center;
      transform: translateY(-50%);
      border-radius: 50%;
      color: ${tokens.colors.white};
      z-index: 1;

      &:before {
        opacity: 1;
        line-height: 35px;
      }

      &:hover {
        background-color: ${tokens.colors.primary};
      }
    }

    .slick-next {
      right: -40px;
      @media screen and (max-width: ${tokens.breakpoints.s}) {
        right: 12px;
      }
    }

    .slick-prev {
      left: -40px;
      @media screen and (max-width: ${tokens.breakpoints.s}) {
        left: 12px;
      }
    }

    .slick-dots {
      bottom: -40px;
    }
  }

  .embeddables-carousel {
    .slick-arrow {
      background-color: ${tokens.colors.grayDarker};
      height: 32px;
      width: 32px;
      display: flex;
      justify-content: center;
      align-items: center;
      transform: translateY(-50%);
      border-radius: 50%;
      color: ${tokens.colors.white};
      z-index: 1;

      &:before {
        opacity: 1;
        line-height: 35px;
      }

      &:hover {
        background-color: ${tokens.colors.primary};
      }
    }

    .slick-next {
      right: -40px;
    }

    .slick-prev {
      left: -40px;
    }

    .slick-dots {
      bottom: -50px;
    }
  }

  .partner-carousel {
    .slick-slide {
      text-align: center;
    }

    .slick-list {
      margin: 0 50px;
    }

    .slick-arrow {
      background-color: ${tokens.colors.grayDarker};
      height: 32px;
      width: 32px;
      display: flex;
      justify-content: center;
      align-items: center;
      transform: translateY(-50%);
      border-radius: 50%;
      color: ${tokens.colors.white};
      z-index: 1;

      &:before {
        opacity: 1;
        line-height: 35px;
      }

      &:hover {
        background-color: ${tokens.colors.primary};
      }
    }

    .slick-next {
      right: 0;
    }

    .slick-prev {
      left: 0;
    }

    .slick-dots {
      bottom: -50px;
    }
  }
`;

export default GlobalStyle;
